export default "__VITE_ASSET__WtHfBCxh__"